import { z } from 'zod/v4';
import { QuestionnaireStatuses } from './questionnaire-create.js';

export const UpdateQuestionnaireParamsSchema = z.object({
  id: z.string().min(1),
});

export type UpdateQuestionnaireParams = z.infer<
  typeof UpdateQuestionnaireParamsSchema
>;

/**
 * Body of `PATCH /api/questionnaires/:id`, ported from the legacy
 * `update.body` JSON Schema.
 *
 * Every field is optional and the update is a **merge**: a key absent from the
 * body keeps its stored value, while an explicit `null` clears `description` or
 * `dueDate`. That is the legacy semantics — the service reads the row first and
 * overlays only the keys the body carries.
 *
 * Unknown keys are stripped rather than rejected (the zod object default),
 * matching the legacy behaviour: the 2025-06 schema declared
 * `additionalProperties: false`, but Fastify's AJV config removed extras
 * silently instead of answering 400.
 *
 * `isTemplate` is deliberately **not** carried over. The legacy schema accepted
 * it and the UPDATE statement never referenced it, so it was accepted-and-
 * ignored noise; stripping it preserves that exact behaviour.
 */
export const UpdateQuestionnaireBodySchema = z.object({
  name: z.string().min(1).max(255).optional(),
  description: z.union([z.string().max(1024), z.null()]).optional(),
  dueDate: z.union([z.iso.datetime(), z.null()]).optional(),
  status: z.enum(QuestionnaireStatuses).optional(),
});

export type UpdateQuestionnaireBody = z.infer<
  typeof UpdateQuestionnaireBodySchema
>;
